export const token = 'token';
export const tokenExpiry = 'tokenExpiry';
export const userGuid = 'userGuid';
export const userName = 'userName';